import Store from './Store';

const ProductStore = new Store('products');

export {ProductStore};